<template>
  <div class="is-flex is-align-center">
    <ra-custom-period-preview
      v-if="custom.start_at"
      :custom-date="custom"
      @change="showDaterange = true"
      @clear="clear"
    />
    <el-dropdown v-else @command="setPeriod">
      <el-button type="plain" size="small">
        {{ periods[period] }} <i class="ra-icon--chevron-down"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(value, key, i) in periods"
          :key="i"
          :class="{ selected: key === period }"
          :command="key"
          :disabled="key === 'last90'"
          >{{ value }}</el-dropdown-item
        >
        <el-dropdown-item :command="'custom'">{{
          custom.title
        }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <ra-custom-period
      :show.sync="showDaterange"
      :title="'Custom date'"
      :button="'Get'"
      @confirm="setCustomPeriod"
    />
  </div>
</template>

<script>
export default {
  name: "RaPeriods",
  props: {},
  data() {
    return {
      period: "lastweek",
      periods: {
        last90: "Last 90 days",
        last60: "Last 60 days",
        last30: "Last 30 days",
        lastweek: "Last week"
      },
      custom: {
        title: "Custom",
        start_at: null,
        end_at: null
      },
      showDaterange: false
    };
  },
  created() {
    this.setPeriod();
  },
  methods: {
    setPeriod(period = "lastweek") {
      if (period === "custom") {
        this.showDaterange = true;
        return;
      }
      this.period = period;
      this.$emit("set-period", {
        start_at: this.formatPeriodDate(this.period),
        end_at: this.formatDate(new Date())
      });
    },
    setCustomPeriod({ start_at, end_at }) {
      this.$emit("set-period", {
        start_at,
        end_at
      });
      this.custom.start_at = start_at;
      this.custom.end_at = end_at;
    },
    clear() {
      this.custom.start_at = null;
      this.custom.end_at = null;
    }
  }
};
</script>
